(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ee-modeles"] && !Shopify.designMode) return;
  try {
    
  /*
   * Le tri par famille d'imprime.
   *
   * Reprend le comportement de l'apercu : un bouton actif a la fois, les
   * cartes hors famille passent en hidden, et le compte de l'en-tete suit le
   * nombre de cartes encore visibles. Le script vaut pour toutes les grilles
   * de la page, pas pour une seule.
   */
  (() => {
    const brancher = (grille) => {
      if (grille.dataset.eeModeles) return;

      const liste = grille.querySelector('.ee-modeles__liste');
      if (!liste) return;
      grille.dataset.eeModeles = 'pret';

      const filtres = [...grille.querySelectorAll('.ee-modeles__filtre')];
      const compte = grille.querySelector('[data-modeles-compte]');

      const appliquer = (choix) => {
        /* On compte les imprimes differents encore visibles, pas les cartes :
           un imprime vendu sur deux fiches ne compte qu'une fois. */
        const visibles = new Set();
        liste.querySelectorAll('.ee-modeles__item').forEach((item) => {
          const garde = choix === 'tous' || item.dataset.famille === choix;
          item.hidden = !garde;
          if (garde) visibles.add(item.dataset.imprime || item);
        });
        filtres.forEach((f) => {
          f.setAttribute('aria-pressed', String(f.dataset.filtre === choix));
        });
        if (compte) compte.textContent = String(visibles.size);
      };

      filtres.forEach((f) => {
        f.addEventListener('click', () => appliquer(f.dataset.filtre));
      });
    };

    const tout = () => document.querySelectorAll('.ee-modeles').forEach(brancher);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tout);
    } else {
      tout();
    }

    /* Le personnalisateur remonte la section a chaque reglage modifie */
    document.addEventListener('shopify:section:load', tout);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-recap-b"] && !Shopify.designMode) return;
  try {
    
  /*
   * Les trois piliers : le texte est dans la page, pose sur la photo.
   *  - souris : le survol ouvre un apercu, qui se referme quand la souris part
   *    (seulement si aucune carte n'est epinglee) ;
   *  - clic (souris ou toucher sur tablette) : la carte s'ouvre et reste
   *    ouverte (epinglee), meme quand la souris part ; un nouveau clic sur la
   *    carte, sur sa croix, un clic ailleurs ou Echap la referme ; ouvrir une
   *    autre carte ferme la precedente ;
   *  - clavier : le focus sur le titre ouvre l'apercu (la carte defile sous la
   *    barre fixe), Entree epingle/ferme, Echap ferme ;
   *  - telephone (< 750px) : le texte se deplie sous la photo, carte par carte.
   * Le script mesure aussi --c-chute : de combien le picto et le titre
   * descendent au repos pour se poser au-dessus de l'indice « + Decouvrir ».
   * Sans ce script, le survol et le focus suffisent (CSS).
   *
   * Dans le personnalisateur, chaque reglage modifie redessine la section :
   * le nouveau contenu arrive sans passer par le chargement de la page. Sans
   * relancer le script (evenement shopify:section:load), les cartes n'ont
   * plus de --c-chute et les titres retombent a une place approchee, plus
   * ou moins basse selon leur longueur.
   */
  const initialiser = (racine) => {
    const sections = [...racine.querySelectorAll('.ee-recap-b')];
    if (racine.matches?.('.ee-recap-b')) sections.push(racine);
    sections.forEach((section) => {
    if (section.dataset.eeCartes) return;

    const cartes = [...section.querySelectorAll('[data-ee-carte]')];
    const piliers = section.querySelector('.ee-recap-b__piliers');
    if (!cartes.length || !piliers) return;
    section.dataset.eeCartes = 'pret';

    const large = matchMedia('(min-width: 750px)');
    const reduit = matchMedia('(prefers-reduced-motion: reduce)');
    const bouton = (carte) => carte.querySelector('.ee-recap-b__bascule');

    const regler = (carte, ouvert, epingle = false) => {
      if (ouvert) carte.dataset.eeOuvert = '';
      else delete carte.dataset.eeOuvert;
      if (ouvert && epingle) carte.dataset.eeEpingle = '';
      else delete carte.dataset.eeEpingle;
      bouton(carte)?.setAttribute('aria-expanded', String(ouvert));
    };
    const fermerAutres = (garder) => cartes.forEach((c) => c !== garder && regler(c, false));
    const toutFermer = () => cartes.forEach((c) => regler(c, false));
    const uneEpinglee = () => cartes.some((c) => c.hasAttribute('data-ee-epingle'));
    const montrer = (carte) => {
      const r = carte.getBoundingClientRect();
      if (r.top < 96 || r.bottom > window.innerHeight - 16) {
        carte.scrollIntoView({ block: 'nearest', behavior: reduit.matches ? 'auto' : 'smooth' });
      }
    };

    /* Mesures (ordinateur et tablette) : texte resserre si besoin, puis la chute du titre */
    const mesurer = () => {
      if (!large.matches) {
        delete piliers.dataset.eeSerre;
        cartes.forEach((c) => c.style.removeProperty('--c-chute'));
        return;
      }
      /* Une carte plus haute que l'ecran (barre fixe deduite) : le texte passe a 14px */
      delete piliers.dataset.eeSerre;
      if (cartes.some((c) => c.offsetHeight > window.innerHeight - 124)) piliers.dataset.eeSerre = '';
      cartes.forEach((c) => {
        const titre = c.querySelector('.ee-recap-b__carte-titre');
        const indice = c.querySelector('.ee-recap-b__indice');
        if (!titre || !indice) return;
        const chute = indice.offsetTop - 16 - (titre.offsetTop + titre.offsetHeight);
        c.style.setProperty('--c-chute', Math.max(0, Math.round(chute)) + 'px');
      });
    };

    let image = 0;
    const planifier = () => {
      if (!image) image = requestAnimationFrame(() => { image = 0; mesurer(); });
    };
    mesurer();

    if ('ResizeObserver' in window) {
      const suivi = new ResizeObserver(planifier);
      cartes.forEach((c) => {
        suivi.observe(c);
        c.querySelectorAll('.ee-recap-b__carte-titre, .ee-recap-b__texte-interne').forEach((el) => suivi.observe(el));
      });
    }
    window.addEventListener('resize', planifier, { passive: true });
    document.fonts?.ready.then(planifier);

    /* On ne referme que si l'ecran passe vraiment de part et d'autre de 750px */
    let etaitLarge = large.matches;
    large.addEventListener?.('change', () => {
      if (large.matches === etaitLarge) return;
      etaitLarge = large.matches;
      toutFermer();
      planifier();
    });

    cartes.forEach((carte) => {
      const b = bouton(carte);
      if (!b) return;

      /* Apercu au survol, tant qu'aucune carte n'est epinglee */
      carte.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse' || !large.matches || uneEpinglee()) return;
        fermerAutres(carte);
        regler(carte, true);
      });

      /* La souris part : l'apercu redescend (pas une carte epinglee, ni le focus clavier) */
      carte.addEventListener('pointerleave', (e) => {
        if (e.pointerType !== 'mouse' || !large.matches) return;
        if (carte.hasAttribute('data-ee-epingle') || b.matches(':focus-visible')) return;
        regler(carte, false);
      });

      /* Un clic n'importe ou sur la carte (photo, titre, « + Decouvrir », croix) */
      carte.addEventListener('click', (e) => {
        if (!large.matches) {
          /* telephone : seule la photo repond, pas le texte deplie dessous */
          if (e.target.closest('.ee-recap-b__texte')) return;
          regler(carte, !carte.hasAttribute('data-ee-ouvert'));
          return;
        }
        /* on vient de selectionner du texte : ne rien refermer */
        const choix = window.getSelection?.();
        if (choix && !choix.isCollapsed && carte.contains(choix.anchorNode)) return;
        if (carte.hasAttribute('data-ee-epingle')) {
          regler(carte, false);
        } else {
          fermerAutres(carte);
          regler(carte, true, true);
          montrer(carte);
        }
      });

      b.addEventListener('focus', () => {
        if (!large.matches || !b.matches(':focus-visible')) return;
        fermerAutres(carte);
        regler(carte, true, carte.hasAttribute('data-ee-epingle'));
        carte.scrollIntoView({ block: 'nearest', behavior: reduit.matches ? 'auto' : 'smooth' });
      });

      b.addEventListener('blur', () => {
        if (large.matches && !carte.hasAttribute('data-ee-epingle') && !carte.matches(':hover')) regler(carte, false);
      });
    });

    /* Un clic ailleurs referme la carte ouverte (pas au telephone : c'est un accordeon) ; Echap aussi */
    document.addEventListener('click', (e) => {
      if (large.matches && !e.target.closest?.('[data-ee-carte]')) toutFermer();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') toutFermer();
    });
    });
  };

  initialiser(document);
  document.addEventListener('shopify:section:load', (e) => initialiser(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
